import React from 'react'
import styles from './index.module.scss'

interface Section7Props {
  message: {
    __green: string
    __contactus: string
  }
}

const Section7: React.FC<Section7Props> = ({ message }) => {
  return (
    <section className={styles.section7}>
      <div className={styles.container}>
        <h2 dangerouslySetInnerHTML={{ __html: message.__green }} />
        <button className={styles.button} onClick={() => window.scrollTo({ top: 0 })}>
          {message.__contactus}
        </button>
      </div>
    </section>
  )
}

export default Section7
